import { defineMessages } from 'react-intl';

export const authMessages = defineMessages({
  invalidLoginMsg: {
    defaultMessage: 'Sorry, we didn`t recognize that email and password.',
    id: 'invalidLoginMsg.error',
  },
  requiredMsg: {
    defaultMessage: 'Oops! Please fill out the required fields.',
    id: 'requiredMsg.error',
  },
  emailMsg: {
    defaultMessage: 'Oops! A valid email address is required.',
    id: 'emailMsg.error',
  },
  forgotPasswordMsgSuccess: {
    id: 'login.forgot-password.success',
    defaultMessage:
      'If an account exists under {email}, we will send login instructions there.',
  },
  forgotPasswordMsgForbidden: {
    id: 'login.forgot-password.forbidden',
    defaultMessage:
      'Contact <a>support@osmosis.org</a> to reset your password.',
  },
  forgotPasswordMsgManyReq: {
    id: 'login.forgot-password.many-requests',
    defaultMessage:
      "You've exceeded the number of password email requests. Please try again in 20 minutes or contact <a>support@osmosis.org</a>",
  },
  invalidEmail: {
    id: 'auth-form.invalidEmail',
    defaultMessage: 'A valid email is required',
  },
  emailRequired: {
    id: 'auth-form.emailRequired',
    defaultMessage: 'Email is required',
  },
  invalidInstitutionalEmail: {
    id: 'auth-form.invalidInstitutionalEmail',
    defaultMessage:
      'Looks like you are using your personal email. You can only use your institutional email here. If you already have a personal Osmosis account, to merge',
  },
  newEmailLabel: {
    id: 'auth-form.emailLabel',
    defaultMessage: 'New email',
  },
  osmosisPasswordLabel: {
    id: 'auth-form.osmosisPasswordLabel',
    defaultMessage: 'Osmosis password',
  },
});
